import React from 'react';
import { PerformanceCard } from './PerformanceCard';
import { OrderProblemCard } from './OrderProblemCard';
import { OrderTotalCard } from './OrderTotalCard';
import { StatsCard } from './StatsCard';

const getPercentage = (value, total, digits) => +(value && total ? (value / total) * 100 : 0).toFixed(digits || 0);

export const CarrierServiceLevel = ({ orderStats, range, carrierId }) => {
  const getLink = (type) => {
    let l = '';
    if (type === 'missing') {
      l = `/orders?confirmedDateFrom=${range[0].toISOString()}&confirmedDateTo=${range[1].toISOString()}&statuses=MISSING`;
    }
    if (type === 'returned') {
      l = `/orders?confirmedDateFrom=${range[0].toISOString()}&confirmedDateTo=${range[1].toISOString()}&statuses=RETURNED,FAILED`;
    }
    if (carrierId) {
      l += `&carrierId=${carrierId}`;
    }
    return l;
  };
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
        <OrderTotalCard
          title="Total"
          subtitle="Orders in total"
          numberOfOrders={orderStats.total.current}
          trend={orderStats.total.trend}
        />
        <OrderProblemCard
          title="Missing"
          subtitle="of the orders went missing"
          percentage={getPercentage(orderStats.missing.current, orderStats.total.current, 1)}
          trend={orderStats.missing.trend}
          link={getLink('missing')}
          statuses="MISSING"
        />
        <OrderProblemCard
          title="Returned"
          subtitle="of the orders were returned to sender"
          percentage={getPercentage(orderStats.returned.current, orderStats.total.current, 1)}
          trend={orderStats.returned.trend}
          link={getLink('returned')}
        />
      </div>
      {orderStats.slas.map((sla, i) => (
        <div key={`${sla.slaThreshold1}${i}`} className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <PerformanceCard data={sla} title="Delivery Attempt" performanceType="attempt" range={range} />
          <PerformanceCard data={sla} title="Successful Delivery" performanceType="completed" range={range} />
        </div>
      ))}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
        <StatsCard
          stats={orderStats.issues}
          totalOrders={orderStats.total.current}
          title="Issues"
          label="orders with issues"
        />
        <StatsCard
          stats={orderStats.claim}
          totalOrders={orderStats.total.current}
          title="Claims"
          label="orders with claim"
        />
      </div>
    </>
  );
};
